// ----------------------------------------------------------------------
// <copyright file="Izenda.Movable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
//</copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var DraggableCore = require('react-draggable').DraggableCore;
  var MovableController = require('./Izenda.MovableController');

  var observer = require('mobx-react').observer;
  var EventName = MovableController.EventName;

  var Movable = React.createClass({
    controller: null,
    propTypes: {
      // Movement event handlers
      [`${EventName.Move}`]: PropTypes.func,
      [`${EventName.MoveStart}`]: PropTypes.func,
      [`${EventName.MoveStop}`]: PropTypes.func,

      // Current movable position (pixel)
      top: PropTypes.number,
      left: PropTypes.number,
      width: PropTypes.number,
      height: PropTypes.number,

      // DraggableCore options
      draggableOptions: PropTypes.object,

      // Top/Left boundary corner
      minTop : PropTypes.number,
      minLeft : PropTypes.number,
      // Right/Bottom boundary corner
      maxRight : PropTypes.number,
      maxBottom : PropTypes.number
    },
    getDefaultProps : function (){
      return {
        minTop : 0,
        minLeft : 0,
        maxRight : Infinity,
        maxBottom : Infinity
      };
    },
    componentWillMount : function () {
      var props = this.props;

      this.controller = props.movableController || new MovableController(
        props.top,
        props.left,
        props.width,
        props.height,
        {
          minTop: props.minTop,
          minLeft: props.minLeft
        },
        {
          maxRight: props.maxRight,
          maxBottom : props.maxBottom
        }
      );

      this.onMoveStart = this.onMoveHandler(EventName.MoveStart);
      this.onMoveStop = this.onMoveHandler(EventName.MoveStop);
      this.onMove = this.onMoveHandler(EventName.Move);
    },
    componentWillReceiveProps : function (nextProps) {
      if(nextProps.maxRight !== this.props.maxRight || nextProps.maxBottom !== this.props.maxBottom) {
        this.controller.updateMaxBoundary(nextProps.maxRight, nextProps.maxBottom);
      }

      if(nextProps.top !== this.props.top
        || nextProps.left !== this.props.left
        || nextProps.width !== this.props.width
        || nextProps.height !== this.props.height){

        this.controller.updatePosition(
          nextProps.top,
          nextProps.left,
          nextProps.width,
          nextProps.height
        );
      }
    },
    render: function (){
      var props = this.props;

      return (
        <DraggableCore
          onStart={this.onMoveStart}
          onDrag={this.onMove}
          onStop={this.onMoveStop}
          {...props.draggableOptions}>

          {props.children}
        </DraggableCore>
      )
    },
    onMoveHandler : function (eventName) {
      var controller = this.controller;
      var moveCallback = this.props[eventName];

      return function (e, dragData){
        var top = this.props.top;
        var left = this.props.left;
        var width = this.props.width;
        var height = this.props.height;

        if(eventName === EventName.MoveStart){
          controller.updatePosition(top, left, width, height);
        }
        controller.moveHandler(eventName, dragData, moveCallback);
      }.bind(this);
    }
  });

  module.exports = observer(Movable);
}();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Movable.jsx